import React from "react";
import { IconButton } from "@mui/material";
import navigateLeft from "../../../assets/images/navigation_left.png";
import navigateRight from "../../../assets/images/navigation_right.png";
import "../css/Pagination.css";

const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => {
  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <div className="trip-request-pagination-container">
      <span className="trip-request-pagination-page-text">Page</span>
      <span className="trip-request-pagination-page-number">
        {totalPages > 1 ? `${currentPage} of ${totalPages}` : "Loading..."}
      </span>
      <IconButton
        onClick={handlePrevious}
        disabled={currentPage === 1}
        className="trip-request-pagination-button"
      >
        <img
          src={navigateLeft}
          alt="Previous Page"
          className="trip-request-pagination-arrow-icon"
        />
      </IconButton>
      <IconButton
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className="trip-request-pagination-button"
      >
        <img
          src={navigateRight}
          alt="Next Page"
          className="trip-request-pagination-arrow-icon"
        />
      </IconButton>
    </div>
  );
};

export default PaginationComponent;
